export const columnsToExport = [
  'tipoTamano',
  'total',
  'fullImport',
  'enTransito',
  'exportEntregados',
  'exportacionTransito',
  'reposicionVaciosOK',
  'vaciosDisponibles',
];
